/**
 * Small in-memory cache for ABS /screen runs so moving Value → Finance in a
 * meeting doesn't wait on the engine twice. Keyed by the full request body.
 */
import { absApi } from '../abs/api.js';

const cache = new Map();
const MAX = 20;

export const DEFAULT_ABS_STRUCTURE = Object.freeze({
  advPv10: 0.6,
  advPp: 0.75,
  targetDscr: 1.25,
  coupon: 0.085,
  tenorYears: 7,
  debtFeePct: 0.01,
});

/** The ABS structure the desk last applied on Finance (shared with Package exports). */
export function deskAbsStructure(desk) {
  const s = desk?.absStructure;
  return s && typeof s === 'object' ? { ...DEFAULT_ABS_STRUCTURE, ...s } : DEFAULT_ABS_STRUCTURE;
}

/** Drop cached ABS runs (logout / session change) so a later session never reuses them. */
export function clearMeetingAbsCache() {
  cache.clear();
}

export function absScreenBody(dealId, structure, desk) {
  const aroSet =
    typeof desk?.aroSet === 'boolean' ? desk.aroSet && Number.isFinite(desk.aroMM) : Number.isFinite(desk?.aroMM) && desk.aroMM > 0;
  return {
    dealId,
    structure: {
      ...structure,
      aroReserveMM: aroSet ? desk.aroMM : 0,
      aroUnknown: !aroSet,
      aroTreatedAsZero: false,
    },
    proposedPurchasePriceMM: desk?.bidPriceMM ?? null,
    generateProgramHedges: true,
  };
}

export function screenCached(body) {
  const key = JSON.stringify(body);
  if (cache.has(key)) return cache.get(key);
  const p = absApi.screen(body).catch((e) => {
    cache.delete(key);
    throw e;
  });
  cache.set(key, p);
  if (cache.size > MAX) cache.delete(cache.keys().next().value);
  return p;
}

/** Fire-and-forget warm-up (e.g. from Value) — errors are ignored here. */
export function warmAbsScreen(dealId, desk) {
  if (!dealId || !desk?.aroSet) return;
  screenCached(absScreenBody(dealId, deskAbsStructure(desk), desk)).catch(() => {});
}
